/**
 * HorizontalCardInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  bottom: ${-200 * Screen.widthRatio}px;
  height: ${172 * Screen.widthRatio}px;
  padding: ${12 * Screen.widthRatio}px ${24 * Screen.widthRatio}px;
  width: ${302 * Screen.widthRatio}px;
`;

export default HorizontalCardInfoContainer;
